export function validation(validatorName) {
    return {
        validatorName: validatorName,
    };
}
export function validationFactory(validatorName) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return {
            validatorName: validatorName,
            validatorArguments: args,
        };
    };
}
//# sourceMappingURL=validation.js.map